const _ = require('lodash');
const fillServerErrors = require('../../../../common/components/servererrorfiller');

function AddressEntryDirective(AddressService, BwsNotificationService, ServerErrorFiller, $rootScope, $templateCache, currentUserService, storePickerService) {
    return {
        restrict: 'E',
        template: require('./billing-address-entry-template.html'),
        transclude: true,
        scope: {
            editModeBillingAddress: '=?',
            nextStep: '&?',
            cancelStep: '&',
            isGuestCheckout: '=?',
            hideCancelBtn: '=?'
        },
        link(scope) {

            scope.currentUser = currentUserService.currentUser;
            scope.guestDetails = {};
            scope.isEligible = false;
            scope.serverErrors = {};
            scope.addressStoreLocatorSearch = {};
            scope.isAddingNewAddress = { mode: true };

            function isValidAddress(address) {
                return (address !== undefined && address.AddressId !== '');
            }

            function buildAddress() {

                const dto = {
                    FirstName: '',
                    LastName: '',
                    ContactNumber: '',
                    AddressMode: 'auto',
                    DeliveryMethod: storePickerService.fulfilmentMethod === 'Pick Up' ? 'Pickup' : 'Delivery',
                    IsForBilling: true,
                    Automatic: {
                        AddressId: '',
                        AddressLabel: '',
                        PostCode: ''
                    },
                    Manual: {
                        Street1: '',
                        Street2: '',
                        PostCode: '',
                        SuburbId: '',
                        State: ''
                    }
                };

                return dto;
            }

            const initialize = function () {
                scope.addressService = AddressService; //TODO: This should never be exposed on the scope!
                scope.loading = true;
                scope.savedAddresses = [];
                scope.showEditManualLink = true;
                scope.modifiedAddress = buildAddress();
                scope.suburbs = [];

                AddressService.getAllAddresses().then(function (addresses) {
                    scope.savedAddresses = addresses.rawResponse;
                    scope.loading = false;
                });

                storePickerService.getFulFilmentInfo().then(() => {
                    scope.fulfilmentInfo = storePickerService.fulfilmentInfo;
                });

                scope.addressItemTemplate = 'address-item-template.html';
                $templateCache.put(scope.addressItemTemplate, require('./billing-address-item-template.html'));
            };

            const resetAddressForm = function () {
                scope.modifiedAddress = buildAddress();
                scope.addressForm.$setPristine();
                scope.addressForm.$setUntouched();
                ServerErrorFiller.clearForm(scope.addressForm, scope);
            };

            const updateAddress = function () {
                $rootScope.$broadcast('myaccount:updateAddress');
                $rootScope.$broadcast('address-update');
                $rootScope.$broadcast('address:newAddressAdded');
                initialize();
            };

            const guardAgainstNull = function (address, func) {
                return (address === undefined || address === null) ? func() : address;
            };

            const isManualAddress = () => {
                scope.modifiedAddress = guardAgainstNull(scope.modifiedAddress, buildAddress);
                return scope.modifiedAddress.AddressMode === 'manual';
            };

            const isAutoAddress = () => {
                scope.modifiedAddress = guardAgainstNull(scope.modifiedAddress, buildAddress);
                return scope.modifiedAddress.AddressMode === 'auto';
            };

            const clearSelectedAddress = () => {
                const autoAddress = scope.modifiedAddress.Automatic;
                autoAddress.AddressId = '';
                autoAddress.PostCode = '';
                scope.showEditManualLink = true;
            };

            scope.isManualAddress = isManualAddress;
            scope.isAutoAddress = isAutoAddress;

            scope.hasSelectedAddress = function () {
                return isValidAddress(scope.modifiedAddress);
            };

            scope.loadSuburbs = function () {
                const postCode = scope.modifiedAddress.Manual.PostCode;
                if (postCode && postCode.length > 0) {
                    AddressService.getSuburbs(scope.modifiedAddress.Manual.PostCode).then(function (suburbs) {
                        scope.suburbs = suburbs;
                        scope.selectSuburb(_.head(suburbs));
                    });
                } else {
                    scope.suburbs = [];
                }
            };

            scope.hasSuburbs = function () {
                return scope.suburbs.length > 0;
            };

            scope.selectSuburb = function (option) {
                if (option) {
                    scope.modifiedAddress.Manual.SuburbId = option.Id;
                }
            };

            function addressTransformer(address) {

                const newAddress = {};

                if (address.AddressMode === 'auto') {
                    _.assign(newAddress, scope.modifiedAddress, scope.modifiedAddress.Automatic);
                } else {
                    _.assign(newAddress, scope.modifiedAddress, scope.modifiedAddress.Manual);

                    newAddress.Suburb = scope.addressStoreLocatorSearch.suburb;
                    newAddress.Postcode = scope.addressStoreLocatorSearch.postcode;
                    newAddress.State = scope.addressStoreLocatorSearch.state;
                }

                return newAddress;
            }

            function saveAddress(dto) {
                if (dto.AddressMode === 'auto') {
                    return AddressService.save(dto);
                }

                return AddressService.saveManual(dto);
            }

            scope.saveAddress = function () {
                if (scope.addressForm.$valid) {
                    scope.loading = true;
                    const dto = addressTransformer(scope.modifiedAddress);
                    
                    saveAddress(dto).then((response) => {
                        scope.loading = false;
                        let errMsg = '';
                        if (response.Success === false || response === false) {
                            if(!_.isEmpty(scope.addressService.savedError)) {
                                let savedErrorData = scope.addressService.savedError.data.ResponseStatus;
                                if(savedErrorData.Errors && !savedErrorData.Errors.length && savedErrorData.Message) {
                                    scope.serverErrors = [{
                                        FieldName: 'ContactNumber',
                                        Message: savedErrorData.Message
                                    }];
                                } else {
                                    scope.serverErrors = savedErrorData.Errors;
                                }
                                
                                errMsg = 'Address was not updated. Please select a valid suburb and postcode from the list';
                            } else {
                                scope.serverErrors = response.FieldErrors;
                                errMsg = 'Address was not updated';
                            }
                            fillServerErrors.fillForm(scope.addressForm, scope.serverErrors, scope);

                            if (scope.addressForm.$valid && errMsg) {
                                BwsNotificationService.error(errMsg);
                            }

                        } else {
                            updateAddress();
                            $rootScope.$broadcast('address:added');
                            scope.editModeBillingAddress.isAddingNewBillingAddress = false;
                        }
                    }, function (response) {
                        fillServerErrors.fillForm(scope.addressForm, response.data.ResponseStatus.Errors, scope);
                        scope.loading = false;
                    });


                }
            };

            scope.useAutoAddress = function () {
                scope.modifiedAddress.AddressMode = 'auto';
                scope.showEditManualLink = true;
            };

            scope.clearAddress = function () {
                scope.modifiedAddress = buildAddress();
            };

            scope.$watch('editModeBillingAddress.isAddingNewBillingAddress', resetAddressForm);

            scope.addManualAddress = function () {
                scope.modifiedAddress.AddressMode = 'manual';
                scope.showEditManualLink = false;
            };

            scope.showManualLink = function () {
                scope.showEditManualLink = true;
            };

            scope.cancelAddNewBillingAddress = function () {
                scope.cancelStep();
            };

            scope.addressOnType = function (searchTerm, fnCallback) {
                AddressService.addressOnType(searchTerm).then((addressList) => {

                    if (_.isFunction(fnCallback)) {
                        fnCallback();
                    }

                    if (addressList.length === 0) { // check if the user has typed a new address
                        clearSelectedAddress();
                    } else {
                        const match = _.find(addressList, (address) => {
                            return address.Postcode === scope.modifiedAddress.Automatic.PostCode;
                        });
                        if (_.isUndefined(match)) clearSelectedAddress();
                    }
                });
            };

            scope.onAddressSelect = function (lookedUpAddress) {
                if (lookedUpAddress && lookedUpAddress.Id) {
                    scope.modifiedAddress.Automatic.AddressId = lookedUpAddress.Id;
                    scope.modifiedAddress.Automatic.AddressLabel = lookedUpAddress.Text;
                    scope.modifiedAddress.Automatic.PostCode = lookedUpAddress.Postcode;
                    scope.showEditManualLink = false;
                } else {
                    clearSelectedAddress();
                    scope.showEditManualLink = false;
                }
            };

            initialize();
        }
    };
}

module.exports = AddressEntryDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/address/billing-address/billing-address-entry-directive.js
 **/